import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://kcfhoruowonbyfyebudz.supabase.co";
const SUPABASE_ANON_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImtjZmhvcnVvd29uYnlmeWVidWR6Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzQ2MjU1NDgsImV4cCI6MjA1MDIwMTU0OH0.RW_twg0erBobQff5sN6009SLYDZOLgxC7Sy-x92u7TQ";

if (!SUPABASE_URL) throw new Error('Missing SUPABASE_URL');
if (!SUPABASE_ANON_KEY) throw new Error('Missing SUPABASE_ANON_KEY');

export const supabase = createClient<Database>(
  SUPABASE_URL,
  SUPABASE_ANON_KEY,
  {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
    },
  }
);